import React, { Fragment } from 'react';
import { createThirdwebClient } from "thirdweb";
import { ConnectButton, TransactionButton, useActiveWalletConnectionStatus, useActiveAccount } from "thirdweb/react";
import { createWallet } from "thirdweb/wallets";
import { sepolia } from "thirdweb/chains"
import { ContractAbi } from '../../../contract/Abi';
import { RolesConstants } from '../../../constants/roles';
import { ContractConstants } from '../../../constants/contract';
import { THIRDWEBConstants } from '../../../constants/thirdweb';
import { getContract, prepareContractCall } from "thirdweb";

/**
 * Blockchain sign button component
 * 
 * Renders Sign Button, a Wallet Connect Button if wallet not connected 
 * or an account switch dropdown if current connected account does not match signer address
 */
export function SignContractButton({contractBc, userType, onAction, onSuccess, onError}) {
    const activeAccount = useActiveAccount();
    const walletConnectionStatus = useActiveWalletConnectionStatus();
    const walletConnected = walletConnectionStatus !== 'connected';
    const walletsMatch = activeAccount?.address.toLowerCase() === contractBc?.contract[userType].toLowerCase();
    const userTypeValid = userType === RolesConstants.HOMEOWNER || userType === RolesConstants.CONTRACTOR;
    const client = createThirdwebClient({ clientId: THIRDWEBConstants.CLIENT_ID });
    const wallets = [createWallet("io.metamask")];

    const getPreparedSignContractCall = () => {
        const contract = getContract({
            client,
            chain: sepolia,
            address: contractBc?.contract.address,
            abi: ContractAbi
        });

        return prepareContractCall({
            contract,
            method: ContractConstants.METHOD.INIT_CONTRACT,
            params: []
        });
    }

    return userTypeValid ? (
        <Fragment>
            {
                (walletConnected || !walletsMatch) &&
            <div className='col-sm-6'>
                {
                    walletConnected ? (
                        "Please connect your wallet to continue"
                    ) : (
                        !walletsMatch ? (
                            "The current connected account does not match the contract " +
                            "address. Please switch to the correct account to continue."
                        ) : (
                            ""
                        )
                    )
                }
            </div>
            }
            <div className='col-sm-6'>
                {
                    walletsMatch ? (
                        <>
                            <TransactionButton
                                className='w-100'
                                theme={'light'}
                                transaction={() => {
                                    return getPreparedSignContractCall();
                                }}
                                onTransactionConfirmed={(receipt) => {
                                    onSuccess(receipt);
                                }}
                                onError={(error) => {
                                    if (typeof onError === 'function') {
                                        onError(error);
                                    }
                                }}
                            >
                                Sign Contract
                            </TransactionButton>
                        </>
                    ) : (
                            <ConnectButton
                                className='w-100'
                                theme={'light'}
                                client={client}
                                wallets={wallets}
                                connectModal={{ size: "compact" }}
                                btnTitle='Connect your wallet'
                            />
                    )
                }
            </div>
        </Fragment>
    ) : (
        <div className='col-sm-12 text-danger'>
            { 
                'Error loading component. Prop userType must be one of ' + 
                `[${RolesConstants.HOMEOWNER}, ${RolesConstants.CONTRACTOR}].`
            } 
        </div>
    )
}